function Apphome(){
    return(
        <div>
            <div class="app text-center  pt-5">
        <div class="contianer">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="mb-3">
                        Get the app now!

                    </h3>
                    <img src="img/app-store-badge.svg" class="img-fluid" alt=""></img>
                    <img src="img/google-play-badge.svg" class="img-fluid " alt=""></img>
                </div>
            </div>
        </div>
    </div>

        </div>
    )
}

export default Apphome ;